export class ColumnNullRate {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "string",
            "format": ""
        },
        {
            "name": "critical",
            "baseName": "critical",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "role",
            "baseName": "role",
            "type": "ColumnRole",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "currentNullRate",
            "baseName": "currentNullRate",
            "type": "number",
            "format": "double"
        },
        {
            "name": "slo",
            "baseName": "slo",
            "type": "number",
            "format": "double"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "HealthStatus",
            "format": ""
        },
        {
            "name": "history",
            "baseName": "history",
            "type": "Array<number>",
            "format": "double"
        }
    ];
    static getAttributeTypeMap() {
        return ColumnNullRate.attributeTypeMap;
    }
    constructor() {
    }
}
